import { render, staticRenderFns } from "./addPrediction.vue?vue&type=template&id=4c58b579&"
import script from "./addPrediction.vue?vue&type=script&lang=js&"
export * from "./addPrediction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports